<template>
  <div class="doExam" v-loading.fullscreen="commitStatus">
    <div id="my-calculator" style="display: none;"></div>
    <div class="headerTop">
      <div class="infoNav">
        <img src="@/assets/images/doExam/pic.jpg" width="75" height="95" class="fl">
        <ul class="fl">
          <li>姓名：{{userName}}</li>
          <li>性别：X</li>
          <li>准考证号：11111111111</li>
          <li>证件号码: 111111111111111111</li>
        </ul>
      </div>
      <div class="fr count-down">
        <!--答题区倒计时-->
        <timer v-if="endTimes>0"
               :end-times.sync="endTimes" />

        <a href="javascript:void (0)"
           @click="handOverFn"
           class="submitbutton">交卷</a>
      </div>
      <div class="tit">{{commonInfo.examName}}</div>
    </div>

    <div class="exam-main">
      <div class="fl leftCon" :style="{width: slideStatus ? '15px':'315px'}">
        <div class="aside-main fl" v-if="!slideStatus">
          <exam-ques-list @quesFn="changeByQueList"></exam-ques-list>
          <div class="aside-info">
            <p>说明：</p>
            <p>1.题号右边的“*”符号代表该小题尚未作答</p>
            <p>2.题号右边的“?”符号代表该小题做过标记</p>
            <p>3.考生作答的同时会自动保存答案</p>
          </div>
          <div class="aside-calc" @click="runCalc" />
        </div>
        <div class="aside-show left">
          <img v-if="slideStatus"
               src="@/assets/images/doExam/open.gif"
               @click="slideStatus=!slideStatus">
          <img v-else
               src="@/assets/images/doExam/close.gif"
               @click="slideStatus=!slideStatus">
        </div>
      </div>
      <div class="fl rightCon" :style="{left: slideStatus ? '15px':'315px'}">
        <div v-if="quesTypeShowMap && quesTypeShowMap[currentQuestion.relOrder]"
           class="explain"
           v-show="visibleInfo">
          {{quesTypeShowMap[currentQuestion.relOrder].showSerialNum}}、
          {{quesTypeShowMap[currentQuestion.relOrder].viewTypeName}}
          {{quesTypeShowMap[currentQuestion.relOrder].quesTypeDesc?'('+quesTypeShowMap[currentQuestion.relOrder].quesTypeDesc+')':''}}
        </div>
        <div class="ques-container">
          <!-- 单选题、判断题 -->
          <template v-if="currentQuestion.quesTypeID === 1 || currentQuestion.quesTypeID === 3">
            <exam-single-choice />
          </template>
          <!-- 多选题 -->
          <template v-if="currentQuestion.quesTypeID === 2">
            <exam-multiple-choice />
          </template>

          <!-- 简答题、综合题、计算分析题(大题套小题，文字题) -->
          <template v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
            <!-- 包含子题目 -->
            <template v-if="currentQuestion.smallContent && currentQuestion.smallContent.length > 0">
              <has-child-question
                ref="hasChildQuestion"
                @runCalc="runCalc"
                @setCurrentSmallContentFn="setCurrentSmallContentFn">
                <!-- <template v-slot:header-num>
                  <strong>第{{currentQuestion.serialNum}}题</strong>
                </template> -->
                <template v-slot:header-func>
                  <a @click="visibleInfo=!visibleInfo">
                    <img src="@/assets/images/doExam/sqtx.gif" v-if="visibleInfo" alt="">
                    <img src="@/assets/images/doExam/zktx.gif" v-else alt="">
                  </a>
                </template>
              </has-child-question>
            </template>
            <!-- 不包含子题目 -->
            <template v-else>
              <without-child-question
                ref="withoutChildQuestion"
                @runCalc="runCalc"
                @setCurrentSmallContentFn="setCurrentSmallContentFn">
                <!-- <template v-slot:header-num>
                  <strong>第{{currentQuestion.serialNum}}题</strong>
                </template> -->
                <template v-slot:header-func>
                  <a @click="visibleInfo=!visibleInfo">
                    <img src="@/assets/images/doExam/sqtx.gif" v-if="visibleInfo" alt="">
                    <img src="@/assets/images/doExam/zktx.gif" v-else alt="">
                  </a>
                </template>
              </without-child-question>
            </template>
          </template>

        </div>

        <div class="bottomBtns">
          <!--底部按钮-->
          <input type="checkbox"
                 :checked="currentQuestion.isMark"
                 :value="1"
                 @click="markToggleFn">标记
          <a href="javascript:void (0)"
             @click="changeQues('prev')"
             :class="[{ preDisabled: preDisabled }, 'preBtn']"
             :disabled="preDisabled">上一题</a>
          <a href="javascript:void (0)"
             @click="changeQues('next')"
             :class="[{ nextDisabled: nextDisabled }, 'nextBtn']"
             :disabled="nextDisabled">下一题 </a>
        </div>

      </div>
    </div>

    <exam-end
      :visible.sync="endExamFlag"
      :isHaveSubjective="isHaveSubjective"
      @viewResults="viewResults"
      @subjectiveQuestionsStore="subjectiveQuestionsStore" ></exam-end>
    <ten-minutes :visible.sync="tenMinutesFlag" />

    <!--给主观题打分-->
    <subjective-mark
      :visible="visibleSub"
       :questionsMap="questionsMap"
       @close="closeSubjective"
      @submit="submitSub" ></subjective-mark>

    <submit-alert
      :visible.sync="visibleAlert"
      :course="commonInfo.examName"
      :multi-status.sync="multiStatus"
      @submit="endToSave"></submit-alert>
  </div>
</template>
<script>
import {
  Timer,
  ExamQuesList,
  ExamSingleChoice,
  ExamMultipleChoice,
  examEnd,
  tenMinutes,
  subjectiveMark,
  hasChildQuestion,
  withoutChildQuestion,
  submitAlert,
} from '@components/exam'

import mixin from '@/mixins/exam'
import mixinCl from '@/mixins/checkLogged'
import { parseNumber, getCookie,LoadingOptions  } from '@/utils'

window._calc_element = 'my-calculator'

export default {
  name: 'DoExam',
  components: {
    Timer,
    ExamQuesList,
    ExamMultipleChoice,
    ExamSingleChoice,
    examEnd,
    tenMinutes,
    subjectiveMark,
    hasChildQuestion,
    withoutChildQuestion,
    submitAlert,
  },
  mixins: [mixin, mixinCl],
  data() {
    return {
      //基础参数
      siteCourseID: 0, //课程ID
      courseID: 0,
      courseName: '', //课程名称
      flag: '', //考试类型
      majorID: 0, //辅导ID
      temp: '', //试卷类型（1，新试卷  2，未完成试卷）
      bizID: '', //试卷ID
      spendTime: 0, //试卷消耗时间
      uid: '', //用户ID
      endTimes: 0,
      timer: null, //计时器
      endExamFlag: false, //结束考试弹框
      visibleAlert: false, //提交试卷弹框
      tenMinutesFlag: false, //十分钟倒计时弹框
      visibleSub: false, //主观题评分弹框
      isHaveSubjective: true, //是否含有主观题
      alertWindow: {
        // 交卷弹窗
        show: false,
        courseName: '',
        unAnswerCount: 0,
        allQuestions: 0,
        isMultipleSelection: false, // 是否多选题只选了一个答案
      },
      questionsMap: [],
      paperRedo: null, //是否是试题重做
      zkzID: '',
      userName: '', //用户名
      commitStatus: false, // 提交接口 执行状态
      slideStatus: false,
      visibleInfo: true, //题目显隐
      multiStatus: false, //alert组件是否显示多选提示
      loadingInstance: null
    }
  },
  watch: {
    endTimes(newVal) {
      document.title = this.timeFilter(newVal)
      if (newVal === 600) {
        this.tenMinutesFlag = true
      }
      if (newVal === 15) {
        clearInterval(this.timer)
      }
      if (!this.endExamFlag && newVal === 0) {
        this.endToSubmit()
      }
    },
  },
  async mounted() {
    const { flag } = this.$route.params
    const {
      siteCourseID,
      temp,
      bizID = '',
      spendTime = 0,
      courseID,
      paperRedo,
      zkzID,
    } = this.$route.query
    const { majorID } = this.$categoryInfo
    this.flag = flag === 'paidExam' ? '' : flag
    this.majorID = majorID
    this.zkzID = zkzID
    this.paperRedo = Number(paperRedo)
    this.courseID = Number(courseID)
    if (this.courseID === 276) this.isShowTable = true
    this.siteCourseID = parseNumber(siteCourseID)
    this.temp = parseNumber(temp)
    this.bizID = parseNumber(bizID)
    this.spendTime = Number(spendTime)
    this.uid = parseNumber(getCookie('cdeluid') || '')
    this.userName = getCookie('username') || ''
    this.loadingInstance = this.$loading(LoadingOptions)
    await this.initExam()

    //计算器实例化
    this.$nextTick(() => {
      window.SetCalcType()
    })


  },
  methods: {

  },
}
</script>
